<template>
<!-- 个人中心 -->
  <div class="myCenter">
    <div class="big-box">
      <el-row class="big-box-top">
        <el-col :span="12" class="left">
          <div class="avatar" @click="avatarUpload">
                <img :src="attachUrl?attachUrl: require('../../assets/img/user-1.png')" alt="">
            <div class="modal"></div>
            <div class="word"> 
                <ab-svg :name="attachUrl?'deleteAvatar':'uploadAvatar'"></ab-svg>
                <p>{{attachUrl? '删除' : '上传头像'}}</p>
            </div>
          </div>
          <div class="info">
            <div>{{step == '99'? personData.companyName : '未签约'}}</div>
            <div><span class="name" v-if="personData.realName">{{personData.realName}}</span> <span style="font-family: DIN_Condensed_Bold">{{personData.loginAccount ? personData.loginAccount.mobile : ''}}</span></div>
          </div>
          <div>
            <el-button type="primary" @click="drawer = true"
              >修改密码</el-button
            >
          </div>
        </el-col>
        <el-col :span="12" class="right" @click="$refs.integralRecord.init()">
          <div>积分</div>
          <div>{{memberInfo.userTotalIntegral || 0}}</div>
        </el-col>
      </el-row>
      <el-row class="big-box-bottom">
        <el-col :span="8">
          <div>注册时间</div>
          <p>{{personData.createTime}}</p>
        </el-col>
        <el-col :span="8">
          <div>邮箱</div>
          <p>{{personData.loginAccount ? personData.loginAccount.email : ''}}</p>
        </el-col>
        <el-col :span="8">
          <div>角色</div>
          <p>{{personData.roles}}</p>
        </el-col>
      </el-row>
    </div>

    <!-- 修改密码 弹框-->
    <div class="password">
      <el-drawer v-model="drawer" :with-header="false" :destroy-on-close='true' @close="drawerClose">
        <el-tabs v-model="activeName" class="passWord">
            <el-tab-pane label="原密码修改" name="dataFrom">
                <el-form
                    :model="dataFrom"
                    status-icon
                    :rules="rules"
                    ref="dataFrom"
                    label-width="100px"
                    class="demo-ruleForm"
                    label-position="top"
                    >
                    <el-form-item prop="password" :required="true" label="原密码">
                        <el-input
                        v-model="dataFrom.password"
                        placeholder="请输入6-18位，包含大小写字母、数字的原密码"
                        />
                    </el-form-item>
                    <el-form-item prop="newPassword" :required="true" label="新密码">
                        <el-input
                        v-model="dataFrom.newPassword"
                        placeholder="请输入6-18位，包含大小写字母、数字的新密码"
                        show-password
                        />
                    </el-form-item>
                    <el-form-item prop="confirmPassword" label="确认新密码">
                        <el-input
                        v-model="dataFrom.confirmPassword"
                        placeholder="请再次输入6-18位，包含大小写字母、数字的新密码"
                        show-password
                        />
                    </el-form-item>
                </el-form>
            </el-tab-pane>

            <el-tab-pane label="验证码修改" name="ruleForm" class="second">
                <div class="phone">手机号码<div>{{userInfos.loginAccount ? userInfos.loginAccount.mobile : ''}}</div></div>
                <el-form
                    :model="ruleForm"
                    status-icon
                    :rules="rules1"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
                    label-position="top"
                    >
                    <el-form-item prop="mobileCode" :required="true" label="验证码">
                        <el-input v-model="ruleForm.mobileCode" placeholder="请输入验证码">
                            <template #append>
                                <el-button link :disabled="isCodeDisabled" @click="checkedPhoneCode">{{phoneCodeBtn}}</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="newPassword" :required="true" label="新密码">
                        <el-input
                            v-model="ruleForm.newPassword"
                            placeholder="请输入6-18位，包含大小写字母、数字的新密码"
                            show-password
                        />
                    </el-form-item>
                    <el-form-item prop="confirmPassword" label="确认新密码">
                        <el-input
                        v-model="ruleForm.confirmPassword"
                        placeholder="请再次输入6-18位，包含大小写字母、数字的新密码"
                        show-password
                        />
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <button aria-label="el.drawer.close" class="el-drawer__close-btn" type="button" style="position: absolute;top: 26px;right: 40px;" @click="drawer = false">
            <i class="el-icon el-drawer__close">
                <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"></path>
                </svg>
            </i>
        </button>
        <template #footer>
          <div style="flex: auto">
            <el-button @click="closePassword">取消</el-button>
            <el-button type="primary" style="margin-left: 20px" :loading="passwordLoading" @click="resetPassword">确定</el-button>
          </div>
        </template>
      </el-drawer>
    </div>

    <!-- 积分记录 -->
    <integral-record :totalIntegral="memberInfo.userTotalIntegral" @exchange="getPrincipalGradeInfo" ref="integralRecord"></integral-record>

    <!-- 上传头像 -->
    <el-dialog
      width="640px"
      append-to-body
      title="上传头像"
      v-model="showAvatarDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="uploadAvatarDialog"
    >
      <el-upload
        class="upload-demo"
        v-if="!option.img"
        drag
        action
        :before-upload="beforeAvatarUpload"
        multiple
      >
        <!-- <el-icon class="el-icon--upload"><upload-filled /></el-icon> -->
        <ab-svg name="upload-file" style=" width: 85px; height: 64px; margin-bottom: 13px"></ab-svg>
        <div class="el-upload__text">
          点击 <em>上传文件</em>，或将文件拖到此窗口即可上传！<br />
          仅支持3MB以内jpg、jpeg、gif、png格式图片上传
        </div>
      </el-upload>

      <div
        v-else
        class="cropperImg"
      >
        <ab-cropperImage
          @uploadImgSuccess="uploadImgSuccess"
          ref="cropper"
          :option="option"
        ></ab-cropperImage>
        <div class="editImg">
          <div style="margin-bottom: 25px">长
            <el-input
              v-model="autoCropWidth"
              @keyup.enter="Enter('autoCropWidth')"
            ></el-input>
          </div>
          <div style="margin-bottom: 25px">宽
            <el-input
              v-model="autoCropHeight"
              @keyup.enter="Enter('autoCropHeight')"
            ></el-input>
          </div>
          <p>注意：支持裁剪最小宽度120最小高度120固定宽高比例为1:1。</p>
        </div>
      </div>

      <template #footer>
        <el-button
          v-if="option.img"
          @click="(()=>{option.img = '';temImg = '';fileName = ''})"
        >重新选择</el-button>
        <el-button
          @click="confirmUpload"
          :type="option.img ? 'primary' : ''"
        >
          {{option.img ? '确 定' : '取 消'}}
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import integralRecord from './integral-record.vue'
export default {
  name: 'my-center',
  components: {
    integralRecord
  },

  data() {
    //校验规则
    const validatePass = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('新密码不能为空'))
        } else {
        // if (/(\w)\1\1/g.test(value)) {
        //     return callback(new Error('密码不能出现3位及以上连续相同字符'))
        // }
        let reg = new RegExp('^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$')
        if (!reg.test(value)) {
            return callback(new Error('请输入6-18位，包含大小写字母、数字的密码'))
        }
        // const LxStr = (str) => {
        //     const arr = str.split('')
        //     let flag = false
        //     for (let i = 1; i < arr.length - 1; i++) {
        //         const firstIndex = arr[i - 1].charCodeAt()
        //         const secondIndex = arr[i].charCodeAt()
        //         const thirdIndex = arr[i + 1].charCodeAt()
        //         if ((thirdIndex - secondIndex === 1) && (secondIndex - firstIndex === 1)) {
        //             flag = true
        //         }
        //     }
        //     return flag
        // }

        // if (LxStr(value)) {
        //     return callback(new Error('密码不允许出现连续3位递增字符'))
        // }
        callback()
        }
    }
    const validatePass2 = (rule, value, callback) => {
        if (!value) {
            callback(new Error("确认密码不能为空"));
        } else if (value !== this.dataFrom.newPassword) {
            callback(new Error("两次输入密码不一致!"));
        } else {
            callback();
        }
    };
    let validateConfirmPassword1 = (rule, value, callback) => {
        if(!value){
            callback(new Error("确认密码不能为空"));
        }else if (this.ruleForm.newPassword !== value) {
            callback(new Error("确认密码与新密码不一致"));
        } else {
            callback();
        }
    };
    return {
        activeName:'dataFrom',
        ruleForm:{},//验证码修改
        personData:{},//用户数据
        memberInfo: {},//积分数据
        memberList:[],//成长值数据
        drawer: false, //修改密码
        phoneCodeBtn: "获取验证码",
        passwordLoading:false,
        isCodeDisabled:false,
        userInfos : this.$utils.getSessionStorage('userInfo') || {},
        dataFrom: {},//原密码修改
        attachUrl:'',//头像信息
        showAvatarDialog:false,//上传头像框显示
        option: {
            accept: 'image/png, image/jpeg, image/gif, image/jpg',    // 上传图片的格式
            img: "", //裁剪图片的地址
            outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
            outputType: "jpeg", //裁剪生成图片的格式（jpeg || png || webp）
            info: true, //图片大小信息
            canScale: true, //图片是否允许滚轮缩放
            autoCrop: true, //是否默认生成截图框
            autoCropWidth: 120, //默认生成截图框宽度
            autoCropHeight: 120, //默认生成截图框高度
            fixed: false, //是否开启截图框宽高固定比例
            fixedNumber: [1, 1], //截图框的宽高比例
            full: false, //false按原比例裁切图片，不失真
            fixedBox: true, //固定截图框大小，不允许改变
            canMove: false, //上传图片是否可以移动
            canMoveBox: true, //截图框能否拖动
            original: true, //上传图片按照原始比例渲染
            centerBox: false, //截图框是否被限制在图片里面
            height: false, //是否按照设备的dpr 输出等比例图片
            infoTrue: true, //true为展示真实输出图片宽高，false展示看到的截图框宽高
            maxImgSize: 3000, //限制图片最大宽度和高度
            enlarge: 1, //图片根据截图框输出比例倍数
            mode: "120px 120px", //图片默认渲染方式
            showBtn: false,  //是否显示按钮
            preview: false,
            width: '292px',
            height: '238px'
        },
        autoCropWidth: '120',
        autoCropHeight: '120',
        //验证规则   Xx1147
        rules: {
            password: [{ required: true, message: "原密码不能为空", trigger: "blur" }],
            newPassword: [
                { validator: validatePass, trigger: "blur", required: true,},
            ],
            confirmPassword: [{ validator: validatePass2, trigger: "blur", required: true }],
        },


        rules1: {
            mobileCode: [
                {required: true, message: '请输入验证码', trigger: 'blur'}
            ],
            newPassword: [
                { validator: validatePass, trigger: "blur", required: true, },
            ],
            confirmPassword: [
                { validator: validateConfirmPassword1, trigger: "blur" }
            ]
        },
    };
  },
  computed:{
    //用户签约情况
    step() {
        return this.$store.state.step
    },
  },
  methods:{
    //个人相关信息请求
    getPersonData () {
       this.$get('/p/user/getByUserCenter')
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.personData = data.result
            this.personData.roles = ''
            this.personData.roleVos.forEach((v) => {
                this.personData.roles = this.personData.roles ? this.personData.roles + '/' + v.name : v.name
            })
           /*  this.personData.tenantVos.forEach((v) => {
                this.personData.tenants = this.personData.tennats ? this.personData.tennats + '/' + v.name : v.name
            })   */
          }
        })   
    },
    //积分相关信息请求
    getMemberInfo(id) {
        this.$get(`/bas/vipGrade/get`, {id}).then(({data}) => {
            if(data && data.code === 'C0000') {
              if(data && data.result) {
                this.memberList = data.result.list && data.result.list.length ? data.result.list : []
              }
            }
        })
        this.getPrincipalGradeInfo()
      /*   this.$get(`/bas/gradePrivilege/get`, {id}).then(({data}) => {
            if(data && data.code === 'C0000') {
              if(data && data.result) {
                this.memberBenefits = data.result.list && data.result.list.length ? data.result.list : []
              }
            }
        }) */
    },
    getPrincipalGradeInfo() {
      this.$get(`/bas/client/vipInfo/getPrincipalGradeInfo`).then(({data}) => {
          if(data && data.code === 'C0000') {
              if(data && data.result) {
              this.memberInfo = data.result
              this.memberInfo.companyGrade = this.memberInfo.companyGrade || 0
              }
          }
      })
    },
    //修改密码取消
    closePassword () {
        this.$refs[this.activeName].resetFields()
        this.drawer = false
    },
    //修改密码确认
    resetPassword(){
        this.$refs[this.activeName].validate((isValid)=>{
            if(isValid){
                this.passwordLoading = true
                let url = this.activeName == 'dataFrom' ? '/p/loginAccount/updatePasswordById' : '/p/user/resetPasswordByMobileCode'
                let data = this.activeName == 'dataFrom' ? {
                    username: this.userInfos.realName,
                    password: this.dataFrom.password,
                    newPassword: this.dataFrom.newPassword,
                    confirmPassword: this.dataFrom.confirmPassword
                }  :  Object.assign({}, this.ruleForm, {id: this.userInfos.id, mobile: this.userInfos.loginAccount.mobile})

                this.$post(url, data).then(({ data }) => {
                    if (data && data.code === 'C0000') {
                         this.$message({
                            type: 'success',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                        setTimeout(() => {
                            this.closePassword()
                        }, 1000)
                        this.getPersonData()
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.message,
                            offset: 380,
                            grouping: true,
                        })
                    }
                }).catch((err) => {
                    this.$message({
                        type: 'error',
                        message: '系统繁忙，请稍后再试',
                        offset: 380,
                        grouping: true,
                    })
                }).finally(() => {
                    this.passwordLoading = false
                })
            }
        })
    },
    //获取头像信息
    getAttachUrl() {
        this.$post('/p/user/getAttachUrlById').then(({data}) => {
            if(data.code === 'C0000') {
            this.attachUrl = data.message
            }
        })
    },
    avatarUpload() {
        if(!this.attachUrl) {
            this.showAvatarDialog = true
        }else{
            this.$post('/p/user/delAttachUrlById').then(({data}) => {
              if(data.code === 'C0000') {
                    this.$message({
                        type: 'success',
                        message: data.message,
                        offset: 380,
                        grouping: true,
                    })
                  this.getAttachUrl()
              }
            })
        }
    },
    upload(data) {
      return this.$http({
        method: 'post',
        url:this.$adornUrl('/p/user/updateAttachUrlById'),
        timeout: 20000 * 60,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data', // 关键
        },
      })
    },
    confirmUpload() {
        if(!this.option.img) {
          this.showAvatarDialog = false
          return
        }
        this.$refs.cropper.$refs.cropper.getCropBlob(async data => {
          let file = new window.File([data], this.fileName, {type: data.type})
          let formData = new FormData();
          formData.append('picture', file);
          this.upload(formData).then(({ data }) => {
            if (data && data.code === 'C0000') {
                this.$message({
                    type: 'success',
                    message: '上传成功',
                    offset: 380,
                    grouping: true,
                })
              this.option.img = ''
              this.temImg = ''
              this.fileName = ''
              this.showAvatarDialog = false
              this.getAttachUrl()
              setTimeout(()=>{
                this.getPersonData()
              })
            }
          })
        })
    },
    Enter(type) {
        if(!/^[1-9]+[0-9]*$/.test(this[type]) || this[type] > 2000) {
            this.$message({
                type: 'error',
                message: '请输入不大于2000的正整数',
                offset: 380,
                grouping: true,
            })
          return
        }
        this.option.autoCropWidth=this['autoCropWidth']
        this.option.autoCropHeight=this['autoCropHeight']
    },
    beforeAvatarUpload (file) {
        const isLtSize = file.size / 1024 / 1024 < 3
        if (!isLtSize) {
            this.$message({
                type: 'error',
                message: file.name + '不能超过3MB!',
                offset: 380,
                grouping: true,
            })
            return false
        }
        let types = ['image/jpeg', 'image/jpg', 'image/gif', 'image/png'];
        const isImage = types.includes(file.type);
            if (!isImage) {
            this.$message({
                type: 'error',
                message: '上传图片只能是 jpg、jpeg、gif、png 格式!',
                offset: 380,
                grouping: true,
            })
            return false
            }
        //转化为blob
        this.fileName = file.name
        let reader = new FileReader();
        reader.onload = e => {
            let data;
            if (typeof e.target.result === "object") {
            data = window.URL.createObjectURL(new Blob([e.target.result]));
            } else {
            data = e.target.result;
            }
            this.temImg = data
            this.option.img=data
        };
        //转化为base64
        reader.readAsDataURL(file);
        return false
    },
    // 获取验证码
    checkedPhoneCode() {
        if(!/^1[0-9]{10}$/.test(this.userInfos.loginAccount.mobile)) {
            this.$message({
                type: 'error',
                message: '手机号格式不正确！',
                offset: 380,
                grouping: true,
            })
            return
        }
        this.isCodeDisabled = true
        let that = this
        this.$post("/p/user/sendChangePwdMobile", {
            mobile: this.userInfos.loginAccount.mobile,
            id: this.userInfos.loginAccount.userId
        }).then(({ data }) => {
            if (data && data.code === "C0000") {
                let index = 60
                let codeTime = setInterval(() => {
                if (index <= 0) {
                    clearInterval(codeTime)
                    that.isCodeDisabled = false
                    that.phoneCodeBtn = "获取手机验证码"
                } else {
                    this.phoneCodeBtn = "重新获取(" + index + ")"
                    index--
                }
                }, 1000);
            } else {
                this.isCodeDisabled = false
                this.$message({
                    type: 'error',
                    message: data.message,
                    offset: 380,
                    grouping: true,
                })
            }
        }).catch(() => {})
    },
    drawerClose(){
        this.$refs.dataFrom.resetFields()
        this.$refs.ruleForm.resetFields()
    }
},
  activated() {
    let userInfo = this.$utils.getSessionStorage('userInfo') || {}
    this.getPersonData(),
    this.getMemberInfo(userInfo.outerOrgId)
    this.getAttachUrl()//头像信息获取
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  mounted(){
    this.$store.commit("activeIndex", '06')
  }
}
</script>

<style lang='scss'>
.myCenter {
  height: 870px;
  .big-box {
    width: 1360px;
    margin: 0 auto;
    text-align: left;
    .big-box-top {
      padding: 40px 0;
      border-bottom: 1px solid #f0f2f5;
      .left {
        display: flex;
        align-items: center;
        border-right: 1px solid #f0f2f5;
        .avatar {
            position: relative;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
            }
            &:hover .modal,.word{
                display: block;
            }
             &:hover .word{
                display: block;
            }
            .modal,.word{
                display: none;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;  
                cursor: pointer;                            
            }
            .modal{
                opacity: .5;
                 
                background-color: #000000; 
            }
            .word{
                color: #fff;
                text-align: center;
                font-size: 14px;
                padding-top: 28px;
                .icon-svg{
                    width: 38px;
                    height: 34px;
                }
            }
        }
        .info {
          width: 60%;
          padding-left: 30px;
          & > div:first-child {
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 25px;
          }
          & > div:last-child {
            display: flex;
            align-items: center;
            font-size: 24px;

            .name {
              padding: 4px 8px;
              color: #f87243;
              background-color: #f0f2f5;
              border-radius: 4px;
              margin-right: 15px;
              font-weight: bold;
              font-size: 16px;
            }
          }
        }
      }
      .right {
        padding-left: 80px;
        cursor: pointer;
        & > div:first-child {
          padding: 15px 0;
          font-size: 14px;
          font-weight: 400;
          color: #636871;
        }
        & > div:last-child {
          font-size: 48px;
          color: #0a7cff;
          font-weight: 500;
          font-family: DIN_Condensed_Bold;
        }
      }
    }
    .big-box-bottom {
      .el-col {
        padding-top: 40px;
        div {
          margin-bottom: 15px;
          font-size: 14px;
          font-weight: 400;
          color: #636871;
        }
        p {
          font-size: 14px;
          font-weight: 500;
          color: #000000;
        }
      }
    }
  }
  //修改密码
  .password {
    text-align: left;
    .el-form-item{
        margin-bottom: 27px;
    }
    .el-drawer.rtl.open {
      border-radius: 16px;
      padding: 0 20px;
      header {
        color: #000;
        margin-bottom: 20px;
        h4 {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
    .icon-svg {
      width: 19px;
      height: 19px;
      vertical-align: middle;
      cursor: pointer;
    }

    .el-drawer__footer {
      text-align: center;
    }
  }
  /*去掉切换时el-tab-pane底部的蓝色下划线*/
    .el-tabs__active-bar {
      background-color: transparent !important;
    }
    /*去掉tabs底部的下划线*/
    .el-tabs__nav-wrap::after {
      position: static !important;
      
    }
    .el-tabs__nav-scroll{
        margin-bottom: 20px;
        .el-tabs__item{
            height: 45px;
        }
      }
    .el-tabs__item.is-top {
      padding: 0;
      margin-right: 40px;
      font-size: 16px;
      &.is-active {
        background-image: url(@/assets/img/nav-active.png);
        background-repeat: no-repeat;
        background-position: bottom;
        border-bottom: none;
        font-size: 18px;
      }
    }
    .el-tabs{
        .second{
            .phone{
                font-size: 14px;
                margin-bottom: 34px;
                div{
                    font-size: 22px;
                    margin-top: 10px;
                    font-weight: 500;
                    font-family: DIN_Condensed_Bold;
                }
            }
        }
        .el-input-group__append{
            width: 90px;
            color: #000000;
            background-color: #f0f2f5;
            font-size: 12px;
            box-shadow:0 0 0 0;
            &::before{
                content: '';
                position: relative;
                left: -30px;
                width: 1px;
                height: 20px;
                background-color: #D2D2D2;
            }
        }
    }
}

.uploadAvatarDialog {
    .el-dialog__body{
        padding: 30px 40px;
    }
  .el-upload-dragger {
    border: none;
    background: none;
  }
  .el-dialog__footer {
    text-align: center;
  }
  .cropperImg {
    display: flex;
    .cropper-content {
      .cropper {
        height: 238px;
      }
      .vue-cropper {
        border-radius: 16px;
      }
    }
    .editImg {
      padding-left: 20px;
      .el-input {
        margin-top: 12px;
      }
      > p {
        color: #F87243;
      }
    }
  }
}
</style>
